import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { NotificationComponent } from './components/notification/notification.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';
import { CustomerService } from './customer/customer.service';
import { AuthService } from './auth/auth.service';
import { HttpService } from './http/http.service';
import { CommonModule } from '@angular/common';
import { NotificationService } from './components/notification/notification.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SpinnerService } from './components/spinner/spinner.service';
import { AuthInterceptor } from './http/auth.interceptor';
import { HelperService } from './helper.service';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { CookieboxModule } from '../cookiebox/cookiebox.module';
import { ClickOutsideDirective } from '@co-3/ctrl-ui/util';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@NgModule({
    declarations: [NotificationComponent, SpinnerComponent, ActionButtonsComponent],
    exports: [NotificationComponent, SpinnerComponent, ActionButtonsComponent],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        CookieboxModule,
        ClickOutsideDirective,
        CtrlIconComponent,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {
    public constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule,
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }

    public static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: 'Window', useValue: window },
                { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
                AuthService,
                HttpService,
                CustomerService,
                SpinnerService,
                NotificationService,
                HelperService,
            ],
        };
    }
}
